import { GetAiLicensesRequest } from '@eggplant/api-requests'
import {
  createContext,
  useState
} from 'react'
import type {
  License,
  LicenseQuery
} from '@eggplant/types'
import type { ReactNode } from 'react'

interface UpmReportingProps {
  isUpmReportingEnabled?: boolean
}

export const UpmReportingContext = createContext<UpmReportingProps | undefined>(undefined)

interface ProviderProps {
  children: ReactNode
  isUpmReportingEnabled?: boolean
}

export const UpmReportingContextProvider = ({
  children,
  isUpmReportingEnabled: isUpmReportingEnabledProp
}: ProviderProps) => {
  const [isUpmReportingEnabled, setIsUpmReportingEnabled] = useState<boolean>(!!isUpmReportingEnabledProp)

  const handleUpmReportingSuccess = (licenseArray: License[]) => {
    setIsUpmReportingEnabled(licenseArray.length > 0)
  }

  const handleUpmReportingError = () => {
    setIsUpmReportingEnabled(false)
  }

  const value = { isUpmReportingEnabled }

  const params: LicenseQuery = {
    active: true,
    license_type: 'UPM'
  }

  return (
    <GetAiLicensesRequest
      onError={handleUpmReportingError}
      onSuccess={handleUpmReportingSuccess}
      params={params}
    >
      {
        () =>
          <UpmReportingContext.Provider value={value}>
            {children}
          </UpmReportingContext.Provider>
      }
    </GetAiLicensesRequest>
  )
}

interface ConsumerProps {
  children: (context: UpmReportingProps) => React.ReactNode
}

export const UpmReportingContextConsumer = ({
  children: renderChildren
}: ConsumerProps) =>
  <UpmReportingContext.Consumer>
    {
      (context?: UpmReportingProps) => {
        if (context === undefined) {
          throw new Error('<UpmReportingContextConsumer /> must be used within <UpmReportingContextProvider />')
        }

        return renderChildren(context)
      }
    }
  </UpmReportingContext.Consumer>
